import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { createAuthGuard, AuthGuardData } from 'keycloak-angular';

export const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {
  const router = inject(Router);
  const { authenticated, grantedRoles, keycloak } = authData;

  if (!authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url
    });
    return false;
  }

  const requiredRole = route.data['role'];
  if (!requiredRole) {
    return true;
  }

  const userRoles = [
    ...grantedRoles.realmRoles,
    ...Object.values(grantedRoles.resourceRoles).flat()
  ];

  if (!userRoles.includes(requiredRole)) {
    await router.navigate(['/unauthorized']);
    return false;
  }

  return true;
};

export const AuthGuard: CanActivateFn = createAuthGuard<CanActivateFn>(isAccessAllowed);
